<template>
  <div :style="{ background: headBg }" class="header-wrap">
    <div class="header">
      <div class="logo"></div>
      <div class="navBox">
        <router-link v-for="item in navlist" :key="item.key" :class="['navItem', item.key === currentNav ? 'cur' : '']"
                     :to="item.url">
          {{ item.text }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "navigation",
  data () {
    return {
      navlist: [
        {
          url: "/",
          text: "首页",
          key: "index",
          tips: "",
        },
        {
          // url: "/",
          url: "/productService",
          text: "产品服务",
          key: "productService",
          tips: "",
        },
        {
          // url: "/",
          url: "/questionnaire",
          text: "问卷调查",
          key: "questionnaire",
          tips: "",
        },
        // {
        //   // url: "/",
        //   url: "/expertThinkTank",
        //   text: "专家智库",
        //   key: "expertThinkTank",
        //   tips: "",
        // },
        {
          // url: "/",
          url: "/company",
          text: "关于我们",
          key: "company",
          tips: "",
        },
        {
          // url: "/",
          url: "/journal",
          text: "期刊介绍",
          key: "journal",
          tips: "",
        },
        {
          // url: "/",
          url: "/schoolCooperation",
          text: "校企合作",
          key: "schoolCooperation",
          tips: "",
        },
        {
          // url: "/",
          url: "/news",
          text: "新闻动态",
          key: "news",
          tips: "",
        },
        {
          // url: "/",
          url: "/recruit",
          text: "人才招聘",
          key: "recruit",
          tips: "",
        },
        {
          // url: "/",
          url: "/contactus",
          text: "联系我们",
          key: "contactus",
          tips: "",
        },
      ],
      grayNavList: ["journalSubmit", "journalDetails"],
      headBg: "#ffffff",
    }
  },
  computed: {
    currentNav: {
      get () {
        return this.$store.state.currentNav
      },
      set (val) {
        return this.$store.commit("updateCurrentNav", val)
      },
    },
    // headBg: {
    //   get() {
    //     if (currentNav) return "";
    //   },
    //   set(val) {
    //     return "";
    //   },
    // },
  },
  watch: {
    // '$route' (res) {
    // 	console.log('路由变化')
    // 	console.log(res)
    // }
    $route: {
      handler (newName) {
        let navData = {
          building: "building",
          contactus: "contactus",
          productService: "productService",
          questionnaire: "questionnaire",
          questionnaireDetails: "questionnaire",
          index: "index",
          news: "news",
          newsDetails: "news",
          company: "company",
          schoolCooperation: "schoolCooperation",
          expertThinkTank: "expertThinkTank",
          recruit: "recruit",
          journal: "journal",
          journalDetails: "journal",
          journalSubmit: "journal",
        }
        this.currentNav = navData[newName.name]
        // this.$store.commit("updateCurrentNav", newName.name);
        if (
          this.grayNavList.findIndex((item) => item === newName.name) !== -1
        ) {
          this.headBg = "#F7F7F7"
        } else {
          this.headBg = "#ffffff"
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 1180px;
  height: 78px;
  // position: absolute;
  // top: 30px;
  // left: 50%;
  // transform: translate(-50%, 0);
  margin: 0 auto;
  z-index: 6;

  .logo {
    flex-shrink: 0;
    width: 264px;
    height: 43px;
    background: url("../../assets/img/common/logo_top.png") no-repeat;
    background-size: cover;
  }

  .navBox {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    height: 44px;
    // min-width: 800px;
    position: relative;

    .navItem {
      height: 30px;
      padding: 0 10px;
      font-size: 18px;
      color: #333333;
      text-align: center;
      line-height: 29px;
      border-radius: 15px;

      &:not(:last-child) {
        margin-right: 10px;
      }

      &.cur,
      &:hover {
        background: #406cdd;
        color: #ffffff;
      }
    }
  }
}
</style>
